"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Dhivehi time in Thaana for timeago.js
 **/
var strings = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: 'ކުރިން',
  suffixFromNow: 'ފަހުން',
  seconds: 'ސިކުންތުކޮޅެއް',
  minute: 'މިނިޓެއްވަރު',
  minutes: '%d މިނިޓު',
  hour: 'ގަޑިއެއްވަރު',
  hours: 'ގާތްގަނޑަކަށް %d ގަޑިއިރު',
  day: 'އެއް ދުވަސް',
  days: 'މީގެ %d ދުވަސް',
  month: 'މަހެއްވަރު',
  months: 'މީގެ %d މަސް',
  year: 'އަހަރެއްވަރު',
  years: 'މީގެ %d އަހަރު',
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;